import { FuseNavigationModelInterface } from '../core/components/navigation/navigation.model';

export class FuseNavigationModel implements FuseNavigationModelInterface {
    public model: any[];

    constructor() {
        this.model = [
            {
                'id': 'home',
                'title': 'Home',
                'translate': 'PAGES.HOME.TITLE',
                'type': 'item',
                'icon': 'home',
                'url': '/pages/home',
                'permission': 'PAGES_HOME',
            }, {
                'id': 'management',
                'title': 'Management',
                'translate': 'PAGES.MANAGEMENT.GROUP_NAME',
                'type': 'group',
                'permission': 'PAGES_MANAGEMENT',
                'children': [
                    {
                        'id': 'users',
                        'title': 'Users',
                        'translate': 'PAGES.MANAGEMENT.USERS',
                        'type': 'item',
                        'icon': 'people',
                        'url': '/pages/management/users',
                        'permission': 'PAGES_MANAGEMENT_USERS'
                    },
                    {
                        'id': 'students',
                        'title': 'Students',
                        'translate': 'PAGES.MANAGEMENT.STUDENTS',
                        'type': 'item',
                        'icon': 'school',
                        'url': '/pages/management/students',
                        'permission': 'PAGES_MANAGEMENT_STUDENTS'
                    },
                    {
                        'id': 'employees',
                        'title': 'Employees',
                        'translate': 'PAGES.MANAGEMENT.EMPLOYEES',
                        'type': 'item',
                        'icon': 'group_work',
                        'url': '/pages/management/employees',
                        'permission': 'PAGES_MANAGEMENT_EMPLOYEE'
                    },
                    {
                        'id': 'schoolyears',
                        'title': 'School Years',
                        'translate': 'PAGES.MANAGEMENT.SCHOOL_YEARS',
                        'type': 'item',
                        'icon': 'date_range',
                        'url': '/pages/management/schoolyear',
                        'permission': 'PAGES_MANAGEMENT_SCHOOL_YEAR'
                    },
                    {
                        'id': 'subjects',
                        'title': 'Subjects',
                        'translate': 'PAGES.MANAGEMENT.SUBJECTS',
                        'type': 'item',
                        'icon': 'subject',
                        'url': '/pages/management/subjects',
                        'permission': 'PAGES_MANAGEMENT_SUBJECTS'
                    },
                    {
                        'id': 'curriculum',
                        'title': 'Curriculum',
                        'translate': 'PAGES.MANAGEMENT.CURRICULA',
                        'type': 'item',
                        'icon': 'book',
                        'url': '/pages/management/curriculum',
                        'permission': 'PAGES_MANAGEMENT_CURRICULUM'
                    },
                    {
                        'id': 'school_schedule',
                        'title': 'School Schedule',
                        'translate': 'PAGES.MANAGEMENT.SCHOOL_SCHEDULE',
                        'type': 'item',
                        'icon': 'schedule',
                        'url': '/pages/events/school-schedule',
                        'permission': 'PAGES_MANAGEMENT_SCHOOL_SCHEDULE'
                    },
                    {
                        'id': 'divisions',
                        'title': 'Divisions',
                        'translate': 'PAGES.MANAGEMENT.DIVISIONS',
                        'type': 'item',
                        'icon': 'view_module',
                        'url': '/pages/management/schoolschedulebyyear',
                        'permission': 'PAGES_MANAGEMENT_DIVISIONS'
                    },
                    {
                        'id': 'professional-concept',
                        'title': 'Profesional Concept',
                        'translate': 'PAGES.MANAGEMENT.PROFESSIONAL_CONCEPT',
                        'type': 'item',
                        'icon': 'library_books',
                        'url': '/pages/management/schoolyearconcept',
                        'permission': 'PAGES_MANAGEMENT_SCHOOL_YEAR_CONCEPT'
                    },
                    {
                        'id': 'schooldata',
                        'title': 'School Data',
                        'translate': 'PAGES.MANAGEMENT.SCHOOLDATA',
                        'type': 'item',
                        'icon': 'business',
                        'url': '/pages/management/schooldata',
                        'permission': 'PAGES_MANAGEMENT_SCHOOLDATA'
                    },
                    {
                        'id': 'examcalls',
                        'title': 'Exam Calls',
                        'translate': 'PAGES.MANAGEMENT.EXAM_CALLS',
                        'type': 'item',
                        'icon': 'assignment',
                        'url': '/pages/management/exam-calls',
                        'permission': 'PAGES_MANAGEMENT_EXAM_CALLS'
                    },
                    {
                        'id': 'actos',
                        'title': 'Actos',
                        'translate': 'PAGES.MANAGEMENT.ACTOS',
                        'type': 'item',
                        'icon': 'event',
                        'url': '/pages/management/actos',
                        'permission': 'PAGES_MANAGEMENT_ACTOS'
                    }
                ]

            },
            {
                'id': 'configuration',
                'title': 'Configuration',
                'translate': 'PAGES.CONFIGURATION.GROUP_NAME',
                'type': 'group',
                'permission': 'PAGES_SECURITY',
                'children': [
                    {
                        'id': 'config-divisions-color',
                        'title': 'Configurar Divisiones',
                        'translate': 'PAGES.CONFIGURATION.DIVISION_COLOR_CONFIG',
                        'type': 'item',
                        'icon': 'color_lens',
                        'url': '/pages/management/divisionscolorconfig',
                        'permission': 'PAGES_SECURITY_ROLES_AND_PERMISSIONS'
                    },
                    {
                        'id': 'index-card-config',
                        'title': 'Configurar Divisiones',
                        'translate': 'PAGES.CONFIGURATION.INDEX_CARD_CONFIGURATION',
                        'type': 'item',
                        'icon': 'library_books',
                        'url': '/pages/management/indexcardconfig',
                        'permission': 'PAGES_SECURITY_ROLES_AND_PERMISSIONS'
                    },
                    {
                        'id': 'report-config',
                        'title': 'Configuración de Reportes',
                        'translate': 'LABELS.REPORT_CONFIGURATION',
                        'type': 'item',
                        'icon': 'picture_as_pdf',
                        'url': '/pages/management/reportconfig',
                        'permission': 'PAGES_SECURITY_ROLES_AND_PERMISSIONS'
                    }
                ]
            },
            {
                'id': 'security',
                'title': 'Security',
                'translate': 'PAGES.SECURITY.GROUP_NAME',
                'type': 'group',
                'permission': 'PAGES_SECURITY',
                'children': [
                    {
                        'id': 'rolesandpermissions',
                        'title': 'Roles and permissions',
                        'translate': 'PAGES.SECURITY.ROLESANDPERMISSIONS',
                        'type': 'item',
                        'icon': 'security',
                        'url': '/pages/security/roles-and-permissions',
                        'permission': 'PAGES_SECURITY_ROLES_AND_PERMISSIONS'
                    }
                ]
            },
            {
                'id': 'news',
                'title': 'News',
                'translate': 'PAGES.NEWS.GROUP_NAME',
                'type': 'group',
                'permission': 'PAGES_NEWS',
                'children': [
                    {
                        'id': 'news_admin',
                        'title': 'News Admin',
                        'translate': 'PAGES.NEWS.NEWS',
                        'type': 'item',
                        'icon': 'library_books',
                        'url': '/pages/management/noticias',
                        'permission': 'PAGES_MANAGEMENT_NEWS'
                    }
                ]
            }
        ];
    }
}



// WEBPACK FOOTER //
// ./src/app/navigation/navigation.model.ts